"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.multiplyWeiAmount = void 0;
const PRECISION = 1e18;
const multiplyWeiAmount = (val1, val2) => {
    return val1 * BigInt(PRECISION * val2) / BigInt(PRECISION);
};
exports.multiplyWeiAmount = multiplyWeiAmount;
//# sourceMappingURL=WeiAmount.js.map